<script lang="ts" setup>
interface Props {
  href: string;
}

defineProps<Props>();
</script>

<template>
  <a
    :href="href"
    class="fixed top-0 left-1/2 z-50 m-3 -translate-x-1/2 -translate-y-16 rounded-full border-2 bg-primary p-3 text-sm font-semibold text-nowrap text-primary-foreground transition focus:translate-y-0 sm:w-[initial]"
  >
    {{ $t('general.skipToMainContent') }}
  </a>
</template>
